import { useLocation } from "react-router-dom";
import type { Locale } from "@/types";

export function useLocale(): Locale {
  const { pathname } = useLocation();
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr";
}
